'use strict';

function CompanySettingInvestigationUsersService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/investigation-users/:investigationUserId', {}, {});
}

angular.module('dokiv')
  .factory('CompanySettingInvestigationUsersService', ['$resource', 'config', CompanySettingInvestigationUsersService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/settings/CompanySettingInvestigationUsersService.js
// module id = 410
// module chunks = 0